import { useContext } from 'react';
import {
	StateContext,
	DynamicStateContext,
	DispatchContext,
} from '../../../../../../../ReactSharedScripts/components/MultiSelectProvider';

export function useSpreadsheetColumnSwitcherState() {
	const context = useContext(StateContext);
	if (context === undefined) {
		throw new Error('useSpreadsheetColumnSwitcherState must be used within a SpreadsheetColumnSwitcherProvider');
	}

	return context;
}

export function useSpreadsheetColumnSwitcherDynamicState() {
	const context = useContext(DynamicStateContext);
	if (context === undefined) {
		//eslint-disable-next-line
		throw new Error(
			'useSpreadsheetColumnSwitcherDynamicState must be used within a SpreadsheetColumnSwitcherProvider',
		);
	}

	return context;
}

export function useSpreadsheetColumnSwitcherDispatch() {
	const context = useContext(DispatchContext);
	if (context === undefined) {
		//eslint-disable-next-line
		throw new Error('useSpreadsheetColumnSwitcherDispatch must be used within a SpreadsheetColumnSwitcherProvider');
	}

	return context;
}
